<a routerLink="/"><h1>DEM Client</h1></a>
<div class="content">
  <nav>
    <a class="item" routerLinkActive="active" routerLink="/materials">Materials</a>
    <a class="item" routerLinkActive="active" routerLink="/particles">Particles</a>
    <a class="item" routerLinkActive="active" routerLink="/meta-particles">Meta Particles</a>
  </nav>
  <div>
    <a class="item user" routerLinkActive="active" routerLink="/user">User Token</a>
    <button class="item" (click)="logout()">Logout</button>
  </div>
</div>
